import { JsDataRestStore } from '@bingads-webui/js-data-rest';

import { RestfulService } from './restful-service';

const restfulService = new RestfulService();
const NotificationStore = new JsDataRestStore({ restfulService });
const NotificationResources = NotificationStore.definitions;

export { NotificationResources, NotificationStore };
